import React from "react";
import { useSelector } from "react-redux";
import Modal from "../../Elements/Modal/Modal";
import Checkbox from "../../Elements/Checkbox/Checkbox";
import LanguageSelector from "../UI/LanguageSelector/LanguageSelector";
import { SimulationSettings } from "../../settings";
import {
  toggleFullscreen,
  toggleSimulationMode,
} from "../../State/Slices/settingsSlice";
import {
  toggleBackgroundMusic,
  toggleSoundEffects,
} from "../../State/Slices/soundsSlice";

const SettingsModal = () => {
  const { modalOpen } = useSelector((state) => state.modal);
  const { soundEffectsEnabled, backgroundMusicEnabled } = useSelector(
    (state) => state.sound
  );
  const { fullscreenEnabled, simulationModeEnabled } = useSelector(
    (state) => state.settings
  );

  return (
    <Modal
      name="settings"
      modifier="modalSettings"
      active={modalOpen}
      title="settings"
    >
      <Checkbox
        action={() => toggleBackgroundMusic()}
        state={backgroundMusicEnabled}
        label="background_music"
      />

      <Checkbox
        action={() => toggleSoundEffects()}
        state={soundEffectsEnabled}
        label="sound_effects"
      />

      <Checkbox
        action={() => toggleFullscreen()}
        label="fullscreen"
        state={fullscreenEnabled}
      />

      {SimulationSettings.SIMULATION_AVAILABLE && (
        <Checkbox
          action={() => toggleSimulationMode()}
          state={simulationModeEnabled}
          label="simulation_mode"
        />
      )}

      <LanguageSelector />
    </Modal>
  );
};

export default SettingsModal;
